shadow$provide[484] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Block:{enumerable:true, get:function() {
  return Block;
}}});
var Graph = require("../graph");
var require$_DOT__DOT__SLASH_linker = require("../linker");
const debug = false;
class Block {
  static previous(outlet) {
    return outlet.input != null ? outlet.input.node.owner : undefined;
  }
  constructor(delay) {
    if (delay == null) {
      delay = false;
    }
    if (!delay) {
      this.construct();
    }
  }
  construct() {
    let left;
    if (this.namespace == null) {
      this.namespace = require$_DOT__DOT__SLASH_linker.Program.entry();
    }
    return this.node = new Graph.Node(this, (left = typeof this.makeOutlets === "function" ? this.makeOutlets() : undefined) != null ? left : {});
  }
  refresh() {
    let left;
    return this.node.setOutlets((left = typeof this.makeOutlets === "function" ? this.makeOutlets() : undefined) != null ? left : {});
  }
  clone() {
    return new Block();
  }
  compile(language, namespace) {
    const program = new require$_DOT__DOT__SLASH_linker.Program(language, namespace != null ? namespace : require$_DOT__DOT__SLASH_linker.Program.entry(), this.node.graph);
    this.call(program, 0);
    return program.assemble();
  }
  link(language, namespace) {
    const module = this.compile(language, namespace);
    const layout = new require$_DOT__DOT__SLASH_linker.Layout(language, this.node.graph);
    this._include(module, layout, 0);
    this.export(layout, 0);
    return layout.link(module);
  }
  call(_program, _depth) {
  }
  callback(_layout, _depth, _name, _external, _outlet) {
  }
  export(_layout, _depth) {
  }
  _info(suffix) {
    let string = (this.node.owner.snippet != null ? this.node.owner.snippet._name : undefined) != null ? this.node.owner.snippet != null ? this.node.owner.snippet._name : undefined : this.node.owner.namespace;
    if (suffix != null) {
      return string += "." + suffix;
    }
  }
  _outlet(def, props) {
    const outlet = Graph.Outlet.make(def, props);
    outlet.meta.def = def;
    return outlet;
  }
  _call(module, program, depth) {
    return program.call(this.node, module, depth);
  }
  _require(module, program) {
    return program.require(this.node, module);
  }
  _inputs(module, program, depth) {
    return (() => {
      const result = [];
      for (const arg of Array.from(module.main.signature)) {
        const outlet = this.node.get(arg.name);
        result.push(__guard__(Block.previous(outlet), x => x.call(program, depth + 1)));
      }
      return result;
    })();
  }
  _callback(module, layout, depth, name, external, outlet) {
    return layout.callback(this.node, module, depth, name, external, outlet);
  }
  _include(module, layout, depth) {
    return layout.include(this.node, module, depth);
  }
  _link(module, layout, depth) {
    debug && console.log("block::_link", this.toString(), module.namespace);
    return (() => {
      const result = [];
      for (const key of Array.from(module.symbols)) {
        const ext = module.externals[key];
        let outlet = this.node.get(ext.name);
        if (!outlet) {
          throw new OutletError(`External not found on ${this._info(ext.name)}`);
        }
        if (outlet.meta.child != null) {
          continue;
        }
        let parent = outlet;
        let block;
        while (!block && parent) {
          [parent, outlet] = Array.from([outlet.meta.parent, parent]);
        }
        block = Block.previous(outlet);
        if (!block) {
          throw new OutletError(`Missing connection on ${this._info(ext.name)}`);
        }
        debug && console.log("callback -\x3e ", this.toString(), ext.name, outlet);
        block.callback(layout, depth + 1, key, ext, outlet.input);
        result.push(block != null ? block.export(layout, depth + 1) : undefined);
      }
      return result;
    })();
  }
  _trace(module, layout, depth) {
    debug && console.log("block::_trace", this.toString(), module.namespace);
    return (() => {
      const result = [];
      for (const arg of Array.from(module.main.signature)) {
        const outlet = this.node.get(arg.name);
        result.push(__guard__(Block.previous(outlet), x => x.export(layout, depth + 1)));
      }
      return result;
    })();
  }
}
const OutletError = function(message) {
  const e = new Error(message);
  e.name = "OutletError";
  return e;
};
OutletError.prototype = new Error();
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};